import { Loader } from '@hivebrite/design-system/Loader';

import { ApplyMenteeForms } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Mentee/ApplyMenteeForms';
import { useGetMenteeProfileFromUser } from 'hb-react/frontoffice/apps/Mentoring/hooks/useGetMenteeProfileFromUser';
import { useGetMenteesCustomAttributes } from 'hb-react/frontoffice/apps/Mentoring/hooks/useGetMenteesCustomAttributes';
import type { Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import { flattenAttributes } from 'hb-react/frontoffice/apps/MyMentoring/utils/flattenAttributesUtils';
import type { User } from 'hb-react/types';

interface ApplicationMenteeProps {
  program: Program;
  currentUser: User;
}

export const ApplicationMentee = ({
  program,
  currentUser,
}: ApplicationMenteeProps) => {
  const { data: customAttributes, isLoading: isLoadingAttributes } =
    useGetMenteesCustomAttributes({
      program,
      queryConfig: {
        is_displayed_in_mentoring_form: true,
      },
    });
  const { data: menteeProfile, isLoading: isLoadingMentee } =
    useGetMenteeProfileFromUser({
      program,
      userId: currentUser.id,
    });

  if (isLoadingAttributes || isLoadingMentee) {
    return <Loader size={40} />;
  }

  const attributes = flattenAttributes(customAttributes);

  return (
    <ApplyMenteeForms
      attributes={attributes}
      program={program}
      menteeProfile={menteeProfile}
    />
  );
};
